import { fetcher } from './fetcher';

export const customInstance = async <T, Body = unknown>({
  url,
  method,
  headers,
  params,
  data,
  signal,
}: {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  params?: any;
  headers?: HeadersInit;
  data?: Body;
  responseType?: string;
  signal?: AbortSignal;
}): Promise<T> => {
  if (params) {
    url += '?' + new URLSearchParams(params);
  }
  const response = await fetcher(url, {
    method,
    headers,
    ...(data ? { body: JSON.stringify(data) } : {}),
    signal,
  });

  return response.json();
};

export default customInstance;
